function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.from-entries.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import styled from "styled-components";
import { flexBasis } from "../core/enhancers/enhancers/flex";
import { maxWidth } from "../core/enhancers/enhancers/size";
import createStyledEnhancer from "../core/enhancers/helpers/createStyledEnhancer";
import { display, flexbox, sizes, spacing, composeEnhancers } from "../core/enhancers";

var gridRow = function gridRow(properties) {
  var row = properties.row;

  if (row) {
    return {
      display: "flex",
      flexWrap: "wrap",
      flexGrow: 0
    };
  }

  return {};
};

var gridColCommonEnhancers = composeEnhancers(flexBasis, maxWidth);

var gridCol = function gridCol(properties) {
  var _properties$row = properties.row,
      row = _properties$row === void 0 ? false : _properties$row,
      theme = properties.theme;
  var _properties$col = properties.col,
      col = _properties$col === void 0 ? !row : _properties$col;
  var _theme$grid = theme.grid;
  _theme$grid = _theme$grid === void 0 ? {} : _theme$grid;
  var columns = _theme$grid.columns,
      breakpointsApi = theme.breakpoints;
  var baseColumnWidth = 100 / (columns || 1);
  var breakpointsEntries = Object.entries(breakpointsApi).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        value = _ref2[1];

    return ["string", "number"].includes(_typeof(value));
  });
  var breakpointsKeys = new Set(breakpointsEntries.map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 1),
        key = _ref4[0];

    return key;
  }));
  var propertyBreakpoints = Object.entries(properties).filter(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 1),
        property = _ref6[0];

    return breakpointsKeys.has(property);
  });

  if (col && propertyBreakpoints.length > 0) {
    var withValue = Object.fromEntries(propertyBreakpoints.map(function (_ref7) {
      var _ref8 = _slicedToArray(_ref7, 2),
          breakpoint = _ref8[0],
          value = _ref8[1];

      return [breakpoint, "".concat(baseColumnWidth * Number(value), "%")];
    }));
    return _objectSpread({
      flexGrow: 0
    }, gridColCommonEnhancers({
      theme: theme,
      maxWidth: withValue,
      flexBasis: withValue
    }));
  }

  return {};
};

var gridOffset = createStyledEnhancer({
  name: "offset",
  directTransformation: true,
  transformation: function transformation(value, _ref9) {
    var theme = _ref9.theme;

    if (!value) {
      return {};
    }

    var _theme$grid2 = theme.grid;
    _theme$grid2 = _theme$grid2 === void 0 ? {} : _theme$grid2;
    var columns = _theme$grid2.columns;
    var baseColumnWidth = 100 / (columns || 1);
    return {
      marginLeft: "".concat(Number(value) * baseColumnWidth, "%")
    };
  }
});
var gridHide = createStyledEnhancer({
  name: "hide",
  directTransformation: true,
  transformation: function transformation(value) {
    return {
      display: value ? "none" : "block"
    };
  }
});
var grid = composeEnhancers(gridCol, gridRow, gridOffset, gridHide);
var GridBox = styled.div.withConfig({
  displayName: "GridBox",
  componentId: "sc-172em67-0"
})({
  boxSizing: "border-box"
}, composeEnhancers(grid, display, flexbox, sizes, spacing));
export default GridBox;